import { ShipmentOrdersStatusChip } from "./ShipmentOrdersStatusChip";
// import ShipmentOrdersCheckbox from "./ShipmentOrdersCheckbox";
import ShipmentOrdersPoNumber from "./ShipmentOrdersPoNumber";

const sortable = true;
export const getItems = (returning = false) => [
  {
    id: "id",
    label: "Number",
  },
  {
    id: "receiver",
    label: "Receiver",
  },
  ...(returning
    ? [
        {
          id: "vendorPo",
          label: "Vendor PO",
        },
      ]
    : []),
  {
    id: "status",
    label: "Status",
  },
  {
    id: "poNumber",
    label: "Customer PO",
  },
  {
    id: "packages",
    label: "Packages",
  },
  {
    id: "createdAt",
    label: "Created Date",
    sortable,
  },
];

export const getKeys = (returning = false) => [
  // {
  //   value: "isChecked",
  //   variant: "small",
  //   CustomComponent: ShipmentOrdersCheckbox,
  // },
  {
    value: "shipmentNumber",
    variant: "blueBold",
    navigate: true,
    route: "shipping",
    id: "id",
  },
  {
    value: "receiver.name",
    variant: "blueBold",
    navigate: true,
    route: "customers",
    id: "receiver.id",
  },
  ...(returning
    ? [
        {
          value: "vendorPo",
          variant: "blueBold",
          navigate: true,
          route: "orders",
          id: "vendorPoId",
        },
      ]
    : []),
  {
    value: "status",
    CustomComponent: ShipmentOrdersStatusChip,
  },
  {
    value: "orders",
    CustomComponent: ShipmentOrdersPoNumber,
  },
  {
    value: "packages",
  },
  {
    value: "createdAt",
    isDate: true,
  },
];
